import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-valor-info',
  templateUrl: './valor-info.component.html',
  styleUrls: ['./valor-info.component.scss']
})
export class ValorInfoComponent implements OnInit {

  constructor() { }
  url = environment.valorWebHook;

  ngOnInit(): void {
  }

}
